<script>
    import { PUBLIC_BASE_URL } from "$env/static/public";
    export let host = PUBLIC_BASE_URL;
    import { closedDates, openingHours } from "../opening-hours/opening-hours";

    const openingHoursMap = Object.keys(openingHours).map((day) => {
        const times = openingHours[day].split("-");
        return {
            day: day[0].toUpperCase() + day.slice(1),
            opens: times[0],
            closes: times[1],
        };
    });

    const jsonOrg = {
        "@context": "http://schema.org",
        "@type": "Organization",
        legalName: "Nylanders Mattor AB",
        url: host,
        contactPoint: [
            {
                "@type": "ContactPoint",
                telephone: "+4633123050",
                contactType: "customer service",
            },
        ],
        logo: host + "images/logo/logo-nylanders-410.png",
        sameAs: ["https://www.facebook.com/NylandersMattorAB", "https://www.youtube.com/nylandersmattor"],
    };
    const jsonldOrg = `<script type="application/ld+json">${JSON.stringify(jsonOrg) + "<"}/script>`;
    const jsonStore = {
        "@context": "http://schema.org",
        "@type": "Store",
        name: "Nylanders Mattor",
        url: host,
        telephone: "+4633123050",
        logo: host + "images/logo/logo-nylanders-410.png",
        geo: {
            "@type": "GeoCoordinates",
            latitude: 57.71889957729446,
            longitude: 13.095375363812597,
        },
        address: {
            "@type": "PostalAddress",
            streetAddress: "Boråsvägen 66",
            postalCode: "51634",
            addressLocality: "Dalsjöfors",
            addressCountry: "Sweden",
        },
        openingHoursSpecification: [
            ...openingHoursMap.map((spec) => {
                return {
                    "@type": "OpeningHoursSpecification",
                    dayOfWeek: [spec.day],
                    opens: spec.opens,
                    closes: spec.closes,
                };
            }),
        ],
        specialOpeningHoursSpecification: [
            ...closedDates.map((day) => {
                return {
                    "@type": "OpeningHoursSpecification",
                    opens: "00:00",
                    closes: "00:00",
                    validFrom: day,
                    validThrough: day,
                };
            }),
        ],
        image: [host + "assets/img/mattor-butik.jpg", host + "assets/img/mattor-butik-2.jpg"],
    };
    const jsonldStore = `<script type="application/ld+json">${JSON.stringify(jsonStore) + "<"}/script>`;
</script>

{@html jsonldOrg}
{@html jsonldStore}
